<template>
  <div class="buttonContent">
    <el-checkbox-button label="不限" :value="noLimit" @change="limitClick()"></el-checkbox-button>
    <el-checkbox-group v-model="value" @change="noLimitClick()">
      <el-checkbox-button
        v-for="(el, i) in codeData"
        :key="i + 'only'"
        :label="el.codeName"
      ></el-checkbox-button>
    </el-checkbox-group>
  </div>
</template>

<script>
import { codeType } from '@/api/common.js'
export default {
  props: {
    typeCode: {
      // 查询的字典值
      type: String,
      default: ''
    },
    code: {
      // 选中的那一项的key
      type: Array,
      default: () => [],
      required: true
    }
  },
  data() {
    return {
      codeData: [],
      value: [],
      noLimit: ['不限']
    }
  },
  created() {
    //如果有穿选中的值就去高亮选中的值并清空不限的选择
    if (this.code.length) {
      this.value = this.code
      this.noLimit = []
    }
    this.getCode()
  },
  watch: {
    value: function (newVal) {
      this.value = newVal
      this.$emit('update:code', newVal)
    }
  },
  methods: {
    //根据code查询标签
    async getCode() {
      const res = await codeType({ code: this.typeCode })
      if (res.data.resultCode == 200) {
        this.codeData = res.data.data
      }
    },
    limitClick() {
      if (this.value.length > 0) {
        this.value = []
        this.noLimit = ['不限']
      }
      let noLimitBoolean
      if (this.noLimit[0] == '不限') {
        noLimitBoolean = []
      } else {
        noLimitBoolean = this.noLimit
      }
      this.$emit('change', noLimitBoolean)
    },
    noLimitClick() {
      if (this.value.length > 0) {
        this.noLimit = []
      } else {
        this.noLimit = ['不限']
      }
      this.$emit('change', this.value)
    }
  }
}
</script>

<style scoped lang="less">
.buttonContent {
  display: flex;
}

/deep/ .el-checkbox-button__inner {
  border: 1px solid #fff !important;
}

/deep/ .el-checkbox-button.is-checked .el-checkbox-button__inner {
  border: 1px solid #17757a !important;
  background-color: #fff;
  color: #17757a;
}

/deep/ .el-checkbox-button__inner:hover {
  color: #17757a;
}

/deep/.el-checkbox-button__inner {
  padding: 9px 10px;
}

// /deep/ .el-checkbox-button.is-focus .el-checkbox-button__inner{
//     border-color:#17757A !important
// }
/deep/ .el-checkbox-button.is-checked .el-checkbox-button__inner {
  box-shadow: none;
}
</style>
